import axios from './axiosInstance'

const setDefaults = () => {
  axios.defaults.headers.common['Content-Type'] =
    'application/x-www-form-urlencode'
  axios.defaults.headers.common.Accept = 'application/json'
}

const AddVenue = ({ token, venue }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios
      .post('/venues/add', venue)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const CheckAlias = ({ alias }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios
      .get(`/venues/checkalias/${alias}`)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const CheckResId = ({ resId }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios
      .get(`/venues/checkresid/${resId}`)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const CheckEmail = ({ email }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios
      .get(`/venues/checkemail/${email}`)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const GetVenue = ({ term, select }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.post('/venues/get/', { term, select }).then((response) => {
      resolve(response.data)
    })
      .catch((error) => {
        reject(error.response)
      })
  })
}

const GetVenueById = ({ _id }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.get(`/venues/id/${_id}`)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const GetVenueLoyalty = ({ token, venue }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios
      .post('/venues/loyalty', { venue })
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const GetVenues = ({ token, data }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios
      .post('/venues', data)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}
const GetAllVenues = ({ token, select }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios.post('/venues/all', { select })
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const GetVenuesStatuses = ({ token }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios
      .post('/venues/statuses')
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const UpdateVenue = ({ token, venue }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios
      .post('/venues/update', venue)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const UpdateVenueStatuses = ({ token, venue }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios
      .post('/venues/updateVenueStatuses', venue)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const UpdateVenueDeliveryAreas = ({ token, venue }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios
      .post('/venues/UpdateVenueDeliveryAreas', venue)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const DeleteVenue = ({ token, uid }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios
      .delete(`/venues/${uid}`)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const ResetPassword = ({ token, userData }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios
      .post('/venues/resetpassword', userData)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const ChangeAlias = ({ token, uid, venueId, newAlias }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios
      .post('/venues/changealias', {
        uid,
        venueId,
        newAlias
      })
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}
const ChangeEmail = ({ token, uid, newEmail }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios
      .post('/venues/changeemail', { uid, newEmail })
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const ControlVenueStatuses = ({ token, venue }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios
      .post('/venues/controlVenueStatuses', { venue })
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const BulkUpdateVenues = ({ token, _ids, venue, range, log }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios
      .post('/venues/bulkupdate', {
        _ids,
        venue,
        range,
        log
      })
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const ImportWH = ({ token, venue }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios
      .post('/venues/importWH', venue)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const ImportDA = ({ token, venue, deliveryAreas }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios
      .post('/venues/importDA', { deliveryAreas, venue })
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const IsWorking = ({ alias }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios
      .get(`/venues/isWorking/${alias}`)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const CheckForColdSale = ({ alias, to }) => {
  setDefaults()
  return new Promise((resolve, reject) => {
    axios
      .post('/venues/checkForColdSale', { alias, to })
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const SearchVenue = ({ token, term }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios
      .get(`/venues/search/${term}`)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}
const ExportVenuesSheet = ({ token }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios
      .get('/venues/exportSheet/')
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const PopulateVenueIds = ({ token, _ids, select }) => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common = { 'auth-token': `${token}` }
    axios
      .post('/venues/populateIds/', { _ids, select })
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const NewVenues = () => {
  return new Promise((resolve, reject) => {
    axios
      .get('/venues/newvenues/')
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}

const PopularVenues = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/venues/popularvenues/', data)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject(error.response)
      })
  })
}
const AddVenueLog   = ({ token, id, log, _id }) => {
  axios.defaults.headers.common = { 'auth-token': `${token}` }
  return new Promise((resolve, reject) => {
    axios
      .post(`/venues/addLog/${id}`, { log, _id })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}
const DeleteVenueLog = ({ token, id, _id }) => {
  axios.defaults.headers.common = { 'auth-token': `${token}` }
  return new Promise((resolve, reject) => {
    axios
      .post(`/venues/deleteLog/${id}`, { _id })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response))
  })
}

export {
  AddVenue,
  GetVenue,
  GetVenueById,
  GetVenues,
  GetAllVenues,
  GetVenuesStatuses,
  DeleteVenue,
  ControlVenueStatuses,
  ChangeAlias,
  ChangeEmail,
  CheckAlias,
  CheckResId,
  CheckEmail,
  UpdateVenue,
  UpdateVenueStatuses,
  UpdateVenueDeliveryAreas,
  ResetPassword,
  BulkUpdateVenues,
  GetVenueLoyalty,
  ImportWH,
  ImportDA,
  IsWorking,
  CheckForColdSale,
  SearchVenue,
  ExportVenuesSheet,
  PopulateVenueIds,
  NewVenues,
  PopularVenues,
  AddVenueLog,
  DeleteVenueLog
}
